import { useIntl } from 'react-intl';

import { Button, Text } from '@calm-web/design-system';

import messages from '@/components/emotion-detector/messages';

import { ErrorText, Form, PasswordInput, StyledCard, Title } from '../styles';

interface PasswordFormProps {
	password: string;
	setPassword: (password: string) => void;
	error: string | null;
	onSubmit: (e: React.FormEvent) => void;
}

export default function PasswordForm({ password, setPassword, error, onSubmit }: PasswordFormProps) {
	const { formatMessage } = useIntl();

	return (
		<StyledCard>
			<Title>
				<Text>{formatMessage(messages.passwordTitle)}</Text>
			</Title>
			<Form onSubmit={onSubmit}>
				<PasswordInput
					type="password"
					value={password}
					onChange={e => setPassword(e.target.value)}
					placeholder={formatMessage(messages.passwordPlaceholder)}
					autoFocus
				/>
				<Button type="submit" backgroundColor="accessibleBrandGradient">
					{formatMessage(messages.passwordUnlock)}
				</Button>
				{error && (
					<ErrorText>
						<Text>{error}</Text>
					</ErrorText>
				)}
			</Form>
		</StyledCard>
	);
}
